//variablen muessen pro instanz angepasst werden
module.exports = {
    mantelUrl : 'https://mantel-api.mobile.documedias.systems/v2/conferences/',
    baseUrl: 'https://mantel-api.mobile.documedias.systems/v2/checkall/',
    baseUrlDownload: 'https://mantel-api.mobile.documedias.systems/v2/downloadall/',
    baseUrlCDN: "https://documedias-188ab.kxcdn.com/",
    api_url : 'https://coredev.api.documedias.systems/api/',
    appointment_api_url : '',//'https://dev.appointment.documedias.systems/api/',
    auth_url : 'https://auth.documedias.com/',
    FILE_SERVER_FOLDER : 'b4222936-3c68-408f-8ca4-f0521bfceabd',
    FILE_SERVER_URL : 'https://fileserver.documedias.systems/',
    VUE_APP_X_API_KEY : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMS0wMi0yNFQxMzowMzoyOC4zMDZaIiwiaWQiOjE1LCJpYXQiOjE2MTQxNzE4MDh9.s5MUeBBlZCyL1kDeegBSUpn7X0FelPnGlGg1pMbxu7c',
    vue_app_access_key : 'eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo5LCJjb25ncmVzc0lkIjoxLCJkYXRlIjoiMjAxOC0xMC0wMVQwOTo0Njo0MC42MDlaIiwiaWF0IjoxNTM4Mzg3MjAwfQ.1Z8vRJF2gZtCuLDEWxQhNyvlYHS6YZsdJxvoYGfyo112afY8CofuEBP4_jvIPXhc',
    cdnInitStamp: "2026-05-05T11:21:00.000Z",//"2025-03-28T16:10:00.000Z"
    conference: '1633',
    short_name: 'bibliocon2026',
    full_name: 'BIBLIOCON 2026',
    api_version: 2, //change this to api version 2 for new conferences!!!
    conf_date : '26 – 30 May',
   //auth_key :'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozNTQyLCJjb25ncmVzc0lkIjoxNjMzLCJkYXRlIjoiMjAyNi0wNC0yN1QwODowOTo1NC4yMzhaIiwiaWF0IjoxNzc3Mjc3Mzk0fQ.xSewBxbpBmzw6DkNG6HhXnsMaksu2YVFzsrI75-UnsE',
    //auth_dev_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozNDM5LCJjb25ncmVzc0lkIjoxNjMzLCJkYXRlIjoiMjAyNi0wMy0wMlQxNDoxOTozMS41NDhaIiwiaWF0IjoxNzcyNDYxMTcxfQ.PPMAL3aENf0d6EqgC4ff1odxdP5Ca0lhXLU5vwJ5WDo',
  //auth_dev_key_web : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozNDM5LCJjb25ncmVzc0lkIjoxNjMzLCJkYXRlIjoiMjAyNi0wMy0wMlQxNDoxOTozMS41NDhaIiwiaWF0IjoxNzcyNDYxMTcxfQ.PPMAL3aENf0d6EqgC4ff1odxdP5Ca0lhXLU5vwJ5WDo',
   auth_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozNTQyLCJjb25ncmVzc0lkIjoxNjMzLCJkYXRlIjoiMjAyNi0wNC0yN1QwODowOTo1NC4yMzhaIiwiaWF0IjoxNzc3Mjc3Mzk0fQ.xSewBxbpBmzw6DkNG6HhXnsMaksu2YVFzsrI75-UnsE',
   auth_dev_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozNTQyLCJjb25ncmVzc0lkIjoxNjMzLCJkYXRlIjoiMjAyNi0wNC0yN1QwODowOTo1NC4yMzhaIiwiaWF0IjoxNzc3Mjc3Mzk0fQ.xSewBxbpBmzw6DkNG6HhXnsMaksu2YVFzsrI75-UnsE',
   auth_dev_key_web : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozNTQyLCJjb25ncmVzc0lkIjoxNjMzLCJkYXRlIjoiMjAyNi0wNC0yN1QwODowOTo1NC4yMzhaIiwiaWF0IjoxNzc3Mjc3Mzk0fQ.xSewBxbpBmzw6DkNG6HhXnsMaksu2YVFzsrI75-UnsE',
    chat_url: 'https://bibliocon2026.chat.documedias.systems/api/',
    favorite_api_url: 'https://bibliocon2026.planner.documedias.systems/api/program/favorites',
    is_multi_conf_app: false, //set true for society or Conf2Go,
    secret_mf:'k3HM1qRe0K+0QX+Eq2JmDV+dTJKnhiQXxu3+7ORwbpA=',
    secret_bluedog: 'ITplW37I+q4g2ZevmHn5x]u0Ayf+oIoMJ6j7ENBar96VI',
    update_user_extra_url : 'https://userextra.cpa.documedias.com',
    main_color: '#173559',
    is_app: false, //unbedingt anpassen bevor App deploy
    versionIOS:'v1.0 11',
    versionAndroid:'v1.0 11',
    loginRequired: false,
    hasMenuBar:false,
    appdata_version: '_v3',
    database_version: 'v3',

    //enable chat routes and show chat link icon in menu
    chat_enabled: false,
    networking_enabled: false,
    has_menulogo: true, 
    has_recommendations : false,
    //menulogo.png icon in menu bar or just conference name
    interactive_url: 'https://bibliocon2026.mobile.documedias.com/interactive',
    mediakapsel_url: 'https://bibliocon2026.documedias.com/mediakapsel2025/'
}
